import { useActivity } from "../../contexts/ActivityContext";
import { Table, TableBody } from "../../design/table";
import ActivityListItem from "../ActivityListItem";
import EmptyStateView from "../EmptyStateView";

interface ActivityListProps {
  eventId?: string;
  fileId?: string;
  participantId?: string;
}

const ActivityList = ({
  eventId,
  fileId,
  participantId,
}: ActivityListProps) => {
  const { activities } = useActivity();

  const currentActivities = activities.filter((activity) => {
    if (eventId && activity.data?.eventId !== eventId) return false;
    if (fileId && activity.data?.fileId !== fileId) return false;
    if (participantId && activity.data?.participantId !== participantId)
      return false;
    return true;
  });

  return (
    <div className="my-4">
      {currentActivities.length === 0 && <EmptyStateView title="No activity" />}
      {currentActivities.length > 0 && (
        <Table>
          <TableBody>
            {currentActivities.map((profile) => (
              <ActivityListItem key={profile._id} activity={profile} />
            ))}
          </TableBody>
        </Table>
      )}
    </div>
  );
};

export default ActivityList;
